import React from 'react';
import PropTypes from 'prop-types';
import { connectStateResults } from 'react-instantsearch/connectors';
import BigCircleSpinner from '../common/components/BigCircleSpinner';
import ErrorContainer from '../common/components/ErrorContainer';

export const SearchResults = ({
  error, searching, searchResults, translations
}) => {
  if (error) {
    return <ErrorContainer errors={[translations.invalidIndex]} />;
  }

  if (searching) {
    return (<BigCircleSpinner />);
  }

  if (searchResults && searchResults.nbHits === 0) {
    return <div>{translations.notFoundMsg}</div>;
  }
  return null;
};

SearchResults.propTypes = {
  error: PropTypes.object,
  searching: PropTypes.bool,
  searchResults: PropTypes.shape({
    hits: PropTypes.array
  }),
  translations: PropTypes.shape({
    notFoundMsg: PropTypes.string.isRequired,
    invalidIndex: PropTypes.string.isRequired
  })
};

export default connectStateResults(props => <SearchResults {...props} />);
